import React, { useState, useEffect } from 'react';
import  { useRef } from 'react';
import AWS from 'aws-sdk';


import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';


import 'font-awesome/css/font-awesome.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { Container, Form, Button } from 'react-bootstrap';
import { Amplify, Auth } from 'aws-amplify';

import { addEntryToDynamoDB, getDownloadCount } from './dynamoDbService'; // Adjust the import path
import config from './appenvdata.json';
import { useAuth } from './AuthContext';

Amplify.configure({
  Auth: {
    identityPoolId: config.identityPoolId,
    region: config.region,
    userPoolId:  config.userPoolId,
    userPoolWebClientId: config.userPoolWebClientId,
  }
});

const credentials = await Auth.currentCredentials();

export function configureAWS(credentials, currentRegion) {
  AWS.config.update({
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken,
    region: currentRegion,
  });
}



function App() {
  const toolName = 'Maptagger'; 
  const { token, userAttributes, logout } = useAuth();
  const [downloadLink, setDownloadLink] = useState('');
  const bucketName = config.MAPtaggingBucketName ; 

  const s3 = new AWS.S3({});
  const fileName = config.MAPtaggingFileName
  const [userEmail, setUserEmail] = useState(null);
  const [userFirstName, setUserFirstName] = useState(null);
  const [userLastName, setUserLastName] = useState(null);
  const [downloadCount, setDownloadCount] = useState(0);
  
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const fetchDownloadCount = async () => {
    try {
      console.log('MapTagger - fetchDownloadCount called');
      const count = await getDownloadCount('Maptagger');
      console.log('MapTagger - received count:', count);
      setDownloadCount(count);
      console.log('MapTagger - downloadCount state set to:', count);
    } catch (error) {
      console.log('Error fetching download count:', error);
      setDownloadCount(0);
    }
  };

  useEffect(() => {
    fetchUserData();
    fetchDownloadCount();

    const getPresignedUrl = async () => {
      try {
     
      const presignedUrl = await generatePresignedUrl(fileName);
    
      setDownloadLink(presignedUrl)
    } catch (error) {
   
      setDownloadLink('');
    }
    };

    getPresignedUrl();
  }, []); // Empty dependency array to run only on mount

 const fetchUserData = async () => {
    try {

     
     setUserEmail(userAttributes.email);
     setUserFirstName(userAttributes.given_name);
     setUserLastName(userAttributes.family_name);
   
      //console.log('Cognito Username:', userData.attributes.email); // Print the Cognito username
    } catch (error) {
      console.log('Error fetching user data: ', error);
    }
  };
  const geturl = async () => {
    try {
     
      const presignedUrl = await generatePresignedUrl(fileName);
    
      setDownloadLink(presignedUrl)
    } catch (error) {
   
      setDownloadLink('');
    }
  };

  const generatePresignedUrl = async (fileName) => {
    const params = {
      Bucket: bucketName,
      Key: fileName,
      Expires: 3600, // URL expiration time in seconds (adjust as needed)
    };

    const presignedUrl = await s3.getSignedUrlPromise('getObject', params);
    return presignedUrl;
  };


   geturl();

   AWS.config.update({
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken,
    region: config.region,
  
  });
  const handleUpdateDB = async (event) => {
    event.preventDefault(); // Prevent default anchor behavior
 
    // Call the function to add entry to DynamoDB
    
    await addEntryToDynamoDB('',toolName,userEmail, userFirstName,userLastName);

  
    // After adding to DynamoDB, you can proceed with the download
    window.location.href = downloadLink; // Initiate download
  };


  return (
    <div>
      <h2 className="heading">MAP Smart Tagger</h2>
      <Container>
        <div className="product-description">
          This tool will help in automating the process of assigning MAP tags.
        </div>

        <div className="container1">
          <div className="product-description">
            <b>Download the Map tagging assets</b>
          </div>

          <div className="file-input-container">
            <div>
              <a
                className="amazon-file-input1"
                href={downloadLink}
                onClick={handleUpdateDB}
                download
              >
                <span>Download</span>
              </a>
            </div>
          </div>

          <div>
            <br />
          </div>

          {/* Expandable README Section */}
          <div >
            <button onClick={toggleExpand} className="expandable-button">
              {isExpanded ? 'Hide README' : 'Show README'}
            </button>
            {isExpanded && (
              <div className="readme-content">
                <h1>MAP Smart Tagger - Deployment Guide</h1>

                <h2>Overview</h2>
                <p>The MAP Smart Tagger is an automated AWS resource tagging solution that uses CloudFormation StackSets to deploy across multiple regions and accounts. It leverages AWS Step Functions, Lambda, and CloudWatch Events to systematically tag AWS resources with MAP (Migration Acceleration Program) tags.</p>

                <h2>Architecture Components</h2>
                <ul>
                  <li><strong>S3 Bucket</strong>: Stores Lambda deployment packages and configuration files</li>
                  <li><strong>IAM Roles</strong>: Provides necessary permissions for cross-region operations</li>
                  <li><strong>Lambda Functions</strong>: Executes tagging logic for different AWS services</li>
                  <li><strong>Step Functions</strong>: Orchestrates the tagging workflow</li>
                  <li><strong>CloudWatch Events</strong>: Triggers automated tagging on a schedule</li>
                </ul>

                <h2>Prerequisites</h2>
                <ul>
                  <li>AWS CLI configured with appropriate permissions</li>
                  <li>CloudFormation StackSet administration permissions</li>
                  <li>Access to target AWS accounts and regions</li>
                  <li>Lambda deployment package (MAPTagging.zip) and state machine files</li>
                </ul>

                <h2>Console Deployment Steps</h2>

                <h3>Step 1: Deploy StackSet Administration and Execution Roles</h3>
                <ol>
                  <li><strong>Navigate to CloudFormation Console</strong>
                    <ul>
                      <li>Go to AWS Console → CloudFormation</li>
                      <li>Ensure you're in your <strong>main region</strong> (us-east-1)</li>
                    </ul>
                  </li>
                  <li><strong>Create Stack</strong>
                    <ul>
                      <li>Click <strong>Create stack</strong> → <strong>With new resources</strong></li>
                      <li>Choose <strong>Upload a template file</strong></li>
                      <li>Upload <code>Roles/StackSetRoles.yml</code></li>
                      <li>Click <strong>Next</strong></li>
                    </ul>
                  </li>
                  <li><strong>Stack Details</strong>
                    <ul>
                      <li>Stack name: <code>StackSetRoles</code></li>
                      <li>Click <strong>Next</strong> (no parameters needed)</li>
                    </ul>
                  </li>
                  <li><strong>Configure Stack Options</strong>
                    <ul>
                      <li>Leave defaults, click <strong>Next</strong></li>
                    </ul>
                  </li>
                  <li><strong>Review and Create</strong>
                    <ul>
                      <li>Check <strong>I acknowledge that AWS CloudFormation might create IAM resources with custom names</strong></li>
                      <li>Click <strong>Submit</strong></li>
                      <li><strong>Wait for CREATE_COMPLETE</strong> before proceeding</li>
                    </ul>
                  </li>
                </ol>

                <h3>Step 2: Create CloudFormation StackSets</h3>

                <h4>2.1 Deploy MAPTaggingBucket StackSet (Main Region Only)</h4>
                <ol>
                  <li><strong>Navigate to StackSets</strong>
                    <ul>
                      <li>Go to CloudFormation → <strong>StackSets</strong></li>
                      <li>Click <strong>Create StackSet</strong></li>
                    </ul>
                  </li>
                  <li><strong>Choose Template</strong>
                    <ul>
                      <li>Select <strong>Upload a template file</strong></li>
                      <li>Upload <code>StackSet-MAPTaggingBucket.yaml</code></li>
                      <li>Click <strong>Next</strong></li>
                    </ul>
                  </li>
                  <li><strong>StackSet Details</strong>
                    <ul>
                      <li>StackSet name: <code>MAPTaggingBucket</code></li>
                      <li>Parameters:
                        <ul>
                          <li><strong>MAPTaggingBucketName</strong>: <code>map-tagging-resource-bucket-YOUR_UNIQUE_SUFFIX</code></li>
                        </ul>
                      </li>
                      <li>Click <strong>Next</strong></li>
                    </ul>
                  </li>
                  <li><strong>Configure StackSet Options</strong>
                    <ul>
                      <li><strong>Administration role ARN</strong>: <code>arn:aws:iam::YOUR_ACCOUNT_ID:role/AWSCloudFormationStackSetAdministrationRole</code></li>
                      <li><strong>Execution role name</strong>: <code>AWSCloudFormationStackSetExecutionRole</code></li>
                      <li>Click <strong>Next</strong></li>
                    </ul>
                  </li>
                  <li><strong>Set Deployment Options</strong>
                    <ul>
                      <li><strong>Add stacks to StackSet</strong>: Check this option</li>
                      <li><strong>Account numbers</strong>: Enter your AWS Account ID</li>
                      <li><strong>Regions</strong>: Select <code>us-east-1</code> only</li>
                      <li>Click <strong>Next</strong></li>
                    </ul>
                  </li>
                  <li><strong>Review and Submit</strong>
                    <ul>
                      <li>Review settings and click <strong>Submit</strong></li>
                      <li><strong>Wait for deployment completion</strong></li>
                    </ul>
                  </li>
                </ol>

                <h4>2.2 Upload Required Files to S3 Bucket</h4>
                <ol>
                  <li><strong>Navigate to S3 Console</strong>
                    <ul>
                      <li>Go to AWS Console → S3</li>
                      <li>Find your bucket: <code>map-tagging-resource-bucket-YOUR_UNIQUE_SUFFIX</code></li>
                    </ul>
                  </li>
                  <li><strong>Upload Files</strong>
                    <ul>
                      <li>Click <strong>Upload</strong></li>
                      <li>Add these files:
                        <ul>
                          <li><code>MAPTagging.zip</code></li>
                          <li><code>StateMachineDefinition.json</code> (rename to <code>StateMachineDefinition.json</code>)</li>
                          <li><code>StateMachineInput.json</code> (rename to <code>StateMachineInput.json</code>)</li>
                        </ul>
                      </li>
                      <li>Click <strong>Upload</strong></li>
                    </ul>
                  </li>
                </ol>

                <h2>Supported AWS Services</h2>
                <p>The solution can tag the following AWS services:</p>
                <ul>
                  <li><strong>Compute</strong>: EC2, Lambda, ECS, EKS</li>
                  <li><strong>Storage</strong>: S3, EBS, EFS</li>
                  <li><strong>Database</strong>: RDS, DynamoDB, ElastiCache</li>
                  <li><strong>Networking</strong>: VPC, Load Balancers, Route53</li>
                  <li><strong>Security</strong>: KMS, Secrets Manager, Security Hub</li>
                  <li><strong>Analytics</strong>: Kinesis, Glue, Athena, QuickSight</li>
                  <li><strong>Machine Learning</strong>: SageMaker, Bedrock, Kendra</li>
                  <li><strong>And many more...</strong></li>
                </ul>

                <h2>Testing the Solution</h2>
                <h3>Step 1: Verify Deployment</h3>
                <ol>
                  <li><strong>Check StackSet Status</strong>
                    <ul>
                      <li>Go to CloudFormation → <strong>StackSets</strong></li>
                      <li>Verify all 3 StackSets show <strong>ACTIVE</strong> status</li>
                    </ul>
                  </li>
                  <li><strong>Check Stack Instances</strong>
                    <ul>
                      <li>Click each StackSet → <strong>Stack instances</strong> tab</li>
                      <li>Verify all instances show <strong>CURRENT</strong> status</li>
                    </ul>
                  </li>
                </ol>

                <h3>Step 2: Manual Execution Test</h3>
                <ol>
                  <li><strong>Navigate to Step Functions</strong>
                    <ul>
                      <li>Go to AWS Console → <strong>Step Functions</strong></li>
                      <li>Select region where you deployed resources</li>
                      <li>Find <strong>MAPTaggingStateMachine</strong></li>
                    </ul>
                  </li>
                  <li><strong>Start Execution</strong>
                    <ul>
                      <li>Click <strong>Start execution</strong></li>
                      <li><strong>Name</strong>: <code>test-execution-manual</code></li>
                      <li>Click <strong>Start execution</strong></li>
                    </ul>
                  </li>
                </ol>

                <h2>Troubleshooting</h2>
                <h3>Common Issues</h3>
                <ol>
                  <li><strong>StackSet Creation Fails</strong>
                    <ul>
                      <li>Verify StackSet roles are properly deployed</li>
                      <li>Check IAM permissions for CloudFormation StackSets</li>
                    </ul>
                  </li>
                  <li><strong>Lambda Function Update Fails</strong>
                    <ul>
                      <li>Ensure S3 bucket is accessible from target regions</li>
                      <li>Verify Lambda deployment package is valid</li>
                    </ul>
                  </li>
                  <li><strong>Step Function Execution Fails</strong>
                    <ul>
                      <li>Check Lambda function logs in CloudWatch</li>
                      <li>Verify IAM permissions for tagging operations</li>
                    </ul>
                  </li>
                </ol>

                <h2>Security Considerations</h2>
                <ul>
                  <li>IAM roles follow least privilege principle</li>
                  <li>S3 bucket has public access blocked</li>
                  <li>Lambda functions run with minimal required permissions</li>
                  <li>Cross-region access is controlled through IAM policies</li>
                </ul>
              </div>
            )}
          </div>

        </div>
      </Container>

      <div className="product-description">
        <div className="container">
          <h3>About</h3>
          <p>
            Owner: <span id="version-number"><b><a className="phone-link" href="https://phonetool.amazon.com/users/sujallur">Sujana Alluru</a></b></span>
          </p>
          <div className="progress-text"></div>
          <p>Current Version: <span id="version-number"><b>2.0</b></span></p>
          <p>Last Updated: <span id="last-updated-date"><b>November 2025</b></span></p>
          <p>Asset use count: <span id="asset-use-count"><b>{downloadCount}</b> </span></p>
          <br />
          <h3>Version History</h3>
          <div className="version-wrapper">
            <p><span id="version-number"><b>Version 1.0</b></span></p>
            <p>This version provides an automated MAP tagging solution for the following AWS services</p>
            <ul>
              <li>EC2 Instances</li>
              <li>EBS Volumes</li>
              <li>Elastic IPs</li>
              <li>Snapshots</li>
              <li>EKS Clusters</li>
              <li>ECS Resources</li>
              <li>CloudWatch Logs Resources</li>
              <li>RDS Resources</li>
              <li>S3 Buckets</li>
              <li>Transfer Family</li>
              <li>Direct Connect Gateways</li>
              <li>Classic Load Balancers</li>
              <li>Application/Network Load Balancers</li>
              <li>Kinesis Analytics Applications</li>
            </ul>
            
            <p><span id="version-number"><b>Version 2.0</b></span></p>
            <p>Uses CloudFormation StackSets to deploy across multiple regions and accounts. Added comprehensive support for the following AWS services:</p>
            <ul>
              
      
              <li>ElastiCache Resources</li>
              <li>Secrets Manager Secrets</li>
              <li>CodeBuild Projects</li>
              <li>ECR Repositories</li>
              <li>KMS Keys</li>
              <li>EFS Filesystems</li>
              <li>Cognito Resources</li>
              <li>Backup Resources</li>
              <li>Lambda Functions</li>
              <li>Route53 Hosted Zones</li>
              <li>API Gateways</li>
              <li>AppSync Resources</li>
              <li>Athena Resources</li>
              <li>ACM Certificates</li>
              <li>CloudHSM Resources</li>
              <li>CodePipeline Resources</li>
              <li>DMS Resources</li>
              <li>DynamoDB Resources</li>
              <li>DataSync Resources</li>
              <li>Bedrock Resources</li>
              <li>CloudFront Distributions</li>
              <li>Glacier</li>
              <li>Kendra Resources</li>
              <li>Firehose Delivery Streams</li>
              <li>Kinesis Data Streams</li>
              <li>QuickSight Resources</li>
              <li>SageMaker Resources</li>
              <li>SNS Topics</li>
              <li>VPC Resources</li>
              <li>Transit Gateway Resources</li>
              <li>VPC Lattice Resources</li>
              <li>Glue Resources</li>
              <li>Security Hub Resources</li>
              <li>Step Functions Resources</li>
              <li>SSM Resources</li>
            </ul>
          </div>
          
          <h3>🚀 Future Enhancements</h3>
          <p>Continuous expansion of supported AWS services and enhanced automation capabilities</p>
        </div>
        <br />
      </div>
    </div>
  );
};

export default App;
